import { RouteRecordRaw } from 'vue-router'

import { MAILCHIMP_ROUTE_NAMES } from '@/modules/mailchimp/constants/MailchimpRouteNames'

import { UserGroup } from '@generated/types'

export const marketingRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/marketing',
    redirect() {
      return { name: MAILCHIMP_ROUTE_NAMES.TEMPLATE_EDIT }
    },
    meta: {
      requiresAuth: UserGroup.OWNERS,
      pageTitle: 'Marketing',
    },
    component: () => import('@/modules/mailchimp/layouts/MarketingLayout.vue'),
    children: [
      {
        path: 'mailchimp',
        name: MAILCHIMP_ROUTE_NAMES.TEMPLATE_EDIT,
        component: () => import('@/modules/mailchimp/pages/MailchimpTemplateEdit.vue'),
        meta: { pageTitle: 'Marketing - Mailchimp' },
      },
      {
        path: '/venue/marketing/analytics/',
        name: MAILCHIMP_ROUTE_NAMES.ANALYTICS,
        component: () => import('@/modules/mailchimp/pages/MarketingAnalytics.vue'),
        meta: { pageTitle: 'Marketing - Analytics' },
      },
    ],
  },
]
